module.exports = "/_next/static/images/indiana-ce81b539151e29ff9d63efad48d49175.svg";